<script setup>
import { useI18n } from 'vue-i18n';

import { XLogo } from '@clicksign/excalibur';

defineProps({
  document: {
    type: Object,
    default: () => ({}),
  },
  isAccessTerm: {
    type: Boolean,
    default: true,
  },
});

const { t } = useI18n();
</script>

<template>
  <div :class="$style.companyInfo">
    <XLogo
      :class="$style.logo"
      color="black"
      height="40px"
      reduced
    />

    <h3 :class="$style.companyName">
      {{ t('accessTerm.display.company_name') }}
    </h3>

    <h4
      v-if="isAccessTerm"
      :class="$style.accessTerm"
    >
      {{ t('accessTerm.display.document_access_term') }}
    </h4>

    <h4
      v-else
      :class="$style.accessTerm"
    >
      {{ t('accessTerm.display.validation') }}
    </h4>

    <p :class="$style.createdTerm">
      {{ document.created_term }}
    </p>
  </div>
</template>

<style lang="scss" module>
.companyInfo {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  .logo {
    margin-bottom: var(--space-medium);
  }

  .companyName {
    margin-bottom: var(--space-medium);
    font-size: var(--font-size-small);
    color: var(--color-neutral-1000);
  }

  .accessTerm {
    margin-bottom: var(--space-small-xx);
    font-size: var(--font-size-large);
  }

  .createdTerm {
    margin-bottom: var(--space-large-x);
    font-size: var(--font-size-small);
    font-weight: var(--font-weight-bold);
  }
}
</style>
